import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, BarChart3, User, Euro, LogOut, Menu, X
} from 'lucide-react';

const InfluencerLayout = ({ children }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      setIsMobile(window.innerWidth < 768);
      setSidebarOpen(window.innerWidth >= 768);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (isMobile) setSidebarOpen(false);
  }, [location.pathname, isMobile]);

  const handleLogout = () => { logout(); navigate('/connexion'); };

  const menuItems = [
    { icon: <LayoutDashboard className="h-5 w-5" />, label: 'Dashboard', path: '/influencer' },
    { icon: <BarChart3 className="h-5 w-5" />, label: 'Statistiques', path: '/influencer/stats' },
    { icon: <Euro className="h-5 w-5" />, label: 'Paiements', path: '/influencer/payouts' },
    { icon: <User className="h-5 w-5" />, label: 'Mon Profil', path: '/influencer/profile' },
  ];

  return (
    <div className="flex h-screen bg-[#0A0A0B] overflow-hidden" data-testid="influencer-layout">
      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-[#121214] border-b border-[#3A3A3D] z-40 px-4 py-3 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-bold text-[#FF6B35]">IPTV4KFR</h1>
          <p className="text-[#6B6B6E] text-xs">Influenceur</p>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-[#B8B8BA] hover:text-[#FF6B35] p-2" data-testid="influencer-mobile-menu">
          {sidebarOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {isMobile && sidebarOpen && (
        <div className="fixed inset-0 bg-black/60 z-40 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`
        fixed md:static inset-y-0 left-0 z-50
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        ${isMobile ? 'w-72' : sidebarOpen ? 'w-64' : 'w-20'}
        bg-[#121214] border-r border-[#3A3A3D] transition-all duration-300 flex flex-col
        ${isMobile ? 'pt-16' : ''}
      `}>
        <div className="hidden md:flex p-6 border-b border-[#3A3A3D] items-center justify-between">
          {sidebarOpen && (
            <div>
              <h1 className="text-xl font-bold text-[#FF6B35]">IPTV4KFR</h1>
              <p className="text-[#6B6B6E] text-xs">Espace Influenceur</p>
            </div>
          )}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-[#B8B8BA] hover:text-[#FF6B35]">
            {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 md:py-6">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => isMobile && setSidebarOpen(false)}
              className={`flex items-center space-x-3 px-4 md:px-6 py-3 transition-colors ${
                location.pathname === item.path
                  ? 'bg-[#FF6B35]/10 border-r-2 border-[#FF6B35] text-[#FF6B35]'
                  : 'text-[#B8B8BA] hover:bg-[#1A1A1D] hover:text-white'
              }`}
              data-testid={`nav-influencer-${item.path === '/influencer' ? 'dashboard' : item.path.split('/').pop()}`}
            >
              {item.icon}
              {(sidebarOpen || isMobile) && <span className="font-medium text-sm">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="p-4 md:p-6 border-t border-[#3A3A3D]">
          <button onClick={handleLogout} className="flex items-center space-x-3 text-[#B8B8BA] hover:text-[#FF3B5C] transition-colors w-full" data-testid="influencer-logout">
            <LogOut className="h-5 w-5" />
            {(sidebarOpen || isMobile) && <span>Déconnexion</span>}
          </button>
        </div>
      </aside>

      <main className={`flex-1 overflow-y-auto ${isMobile ? 'pt-16' : ''}`}>
        {children}
      </main>
    </div>
  );
};

export default InfluencerLayout;
